import { useCallback, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const useDebouncedState = <T>(
  defaultValue: T,
  callback: (val: T) => void,
  delay = 100,
) => {
  const [value, setValue] = useState<T>(defaultValue);

  const debounced = useDebouncedCallback((value) => {
    callback(value);
  }, delay);

  const changeHandler = useCallback(
    (val: T) => {
      setValue(val);
      debounced(val);
    },
    [debounced],
  );

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return [value, changeHandler, setValue] as const;
};
